import { toArray } from '../core.print-ast.js';

function transformAST(root, onNodeVisited, depth = 0, parent = null) {
  const transformedRoot = toArray(root).map((originalNode) => structuredClone(originalNode)).map(
    (rootNode, index) => onNodeVisited(rootNode, {
      depth,
      index,
      parentNode: parent,
      siblingNodes: parent ? parent && "children" in parent ? toArray(parent.children) : [] : toArray(root)
    })
  ).flatMap((it) => it).filter((it) => it !== null);
  for (const untypedRootNode of transformedRoot) {
    const rootNode = untypedRootNode;
    if (!(rootNode == null ? void 0 : rootNode.children)) {
      continue;
    }
    const children = Array.isArray(rootNode.children) ? rootNode.children : [rootNode.children];
    rootNode.children = transformAST(
      children,
      onNodeVisited,
      depth + 1
    );
  }
  return transformedRoot;
}

export { transformAST };
//# sourceMappingURL=core.transform-ast.js.map
